


































import { Nullable } from '@homeserve/od-typings/utils';
import { Component, Emit, Model, Prop, Vue } from 'vue-property-decorator';

interface IVMenu extends Vue {
  save(date: string): void;
}

@Component
export default class DatePickerField extends Vue {
  @Model('change', { type: String, default: () => null })
  public readonly date!: Nullable<string>;

  @Prop({ type: String, default: null })
  public max!: Nullable<string>;

  @Prop({ type: String, default: null })
  public min!: Nullable<string>;

  public menu = false;
  public value: Nullable<string> = this.date;

  @Emit('change')
  public clearDate() {
    return null;
  }

  @Emit('change')
  public closePicker(date: string) {
    (this.$refs.menu as IVMenu).save(date);

    return date;
  }
}
